export default __webpack_public_path__ + "static/media/sketch-04.99b5350e.jpg";